import React from 'react'
import { useTranslation } from 'react-i18next';
interface LangTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  lngKey: string
  values?: Record<string, unknown>
  fallback?: string
}
const LangText = ({ children, lngKey, values, fallback, ...props }: LangTextProps) => {
  const { t } = useTranslation();
  return <span lng-key={lngKey} {...props}>{children ?? t(lngKey, { defaultValue: fallback, ...values })}</span>
}

export { LangText }
